export enum SystemUpgradeState {
  OPERATIONAL = 'operational',
  IN_PROGRESS = 'in-progress',
  FAILED = 'failed',
}

export interface SystemUpgrade {
  state: SystemUpgradeState;
  message?: string;
}
